import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { statusFormatter, localeFormatter, dateTimeFormatter } from '../../../utils/formatters';
import { getViolationStatusDisplayValue, VIOLATION_STATUS_NAMES } from '../../../configs';
import {
  getEvacuationApplicationDetailsUrl,
  getEvacuationApplicationId,
  getEvacuationApplicationLonLat,
  getEvacuationApplicationTitle,
} from '../evacuationApplications';

const formatCoordinates = application => {
  const coordinates = getEvacuationApplicationLonLat(application);
  if (!coordinates) {
    return 'Нет координат';
  }
  return `${coordinates[1].toFixed(6)}, ${coordinates[0].toFixed(6)}`;
};

const openDetails = application => event => {
  event.preventDefault();
  event.stopPropagation();
  window.location.href = getEvacuationApplicationDetailsUrl(application);
};

export default function EvacuationsList(props) {
  const {
    handleSelect = () => {},
    selected = null,
    evacuationsList = [],
    searchValue = '',
    onSearchChange = () => {},
    totalCount = 0,
    markersCount = 0,
    skippedWithoutCoordinates = 0,
  } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="list-columns card py-3">
      <div className="list-header px-3">
        <div className="fs-5 fw-semibold ">{formatMessage({ id: 'menu.evacuations' })}</div>
        <div className="list-header-counter">{markersCount}/{totalCount}</div>
      </div>
      <div className="filter-row px-3 mt-3">
        <TextInput
          className="no-border"
          placeholder="Поиск"
          inputProps={{
            name: 'search',
            value: searchValue,
            onChange: event => onSearchChange(event.target.value),
          }}
          inputBefore={(
            <div className="search-wrapper">
              <Icons customIcon className="search" width={24} height={24} icon="search" />
            </div>
          )}
        />
      </div>
      <div className="list-summary px-3">
        <span>Маркеров: {markersCount}</span>
        {skippedWithoutCoordinates > 0 ? <span>Без координат: {skippedWithoutCoordinates}</span> : null}
      </div>
      <div className="list-content-wrapper">
        <div className="list-content-body custom-scroll-theme list-group list-group-flush border-bottom">
          {!evacuationsList.length ? (
            <div className="evacuations-empty-state px-3 py-4">
              <div className="fw-semibold">Нет данных</div>
              <div className="small">Нет заявок для отображения.</div>
            </div>
          ) : null}
          {evacuationsList.map(evacuation => {
            const id = getEvacuationApplicationId(evacuation);
            return (
              <div
                key={id}
                className={classNames('list-group-item list-group-item-action py-3 lh-sm pointer', { active: id === selected })}
                onClick={handleSelect(evacuation)}
              >
                <div className="d-flex w-100 align-items-start justify-content-between">
                  <div className="list-item-main">
                    <div className="list-item-name">
                      <strong className="mb-1">{getEvacuationApplicationTitle(evacuation)}</strong>
                    </div>
                    <div className="small text-muted evacuation-id">{id}</div>
                  </div>
                  <Button className="small-button ms-2" variant="second" onClick={openDetails(evacuation)}>
                    <Icons icon="info-lg" />
                    <span>Открыть</span>
                  </Button>
                </div>
                <div className="w-100 mb-1 mt-2 small">{statusFormatter(getViolationStatusDisplayValue(evacuation?.status), 'violation.status', VIOLATION_STATUS_NAMES)}</div>
                <div className="evacuation-list-details small">
                  <div><span>Провайдер:</span> {evacuation?.provider_name || 'Нет данных'}</div>
                  <div><span>ИД ТС:</span> {evacuation?.vehicle_id || 'Нет данных'}</div>
                  <div><span>Координаты:</span> {formatCoordinates(evacuation)}</div>
                  <div><span>Тип:</span> {evacuation?.violation_type ? localeFormatter('violation.type', evacuation.violation_type) : 'Нет данных'}</div>
                  <div><span>Создана:</span> {dateTimeFormatter(evacuation?.created_at) || 'Нет данных'}</div>
                </div>
                {evacuation?.description ? <div className="small mt-2 evacuation-description">{evacuation.description}</div> : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
